<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar flat color="white">
        <v-dialog v-model="dialog" max-width="1000px">
          <v-card>
            <v-card-title>
              <span class="headline">Select an item</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-text-field v-model="texto" @keyup.enter="listarArticulos()" class="text-xs-center"
                      append-icon="search" label="Search"></v-text-field>
                    <template>
                      <v-data-table :headers="headerArticulo" :items="articulos" class="elevation-1">
                        <template v-slot:[`item.seleccionar`]="{ item }">
                          <td class="justify-center layout px-0">
                            <v-icon small class="mr-2" @click="agregarDetalle(item)">add_circle</v-icon>
                          </td>
                        </template>
                        <template v-slot:[`item.estado`]="{ item }">
                          <div v-if="item.estado">
                            <span class="blue--text">Active</span>
                          </div>
                          <div v-else>
                            <span class="red--text">Inactive</span>
                          </div>
                        </template>
                      </v-data-table>
                    </template>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="adModal" max-width="500px">
          <v-card>
            <v-card-title class="headline" v-if="adAccion == 1">Activate Item</v-card-title>
            <v-card-title class="headline" v-if="adAccion == 2">Deactivate Item</v-card-title>
            <v-card-text>
              You have selected to
              <span v-if="adAccion == 1" class="blue--text">ACTIVATE</span>
              <span v-if="adAccion == 2" class="red--text">DEACTIVATE</span>
              the item {{ adNombre }}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="activarDesactivarCarrar()">Cancel</v-btn>

              <v-btn v-if="adAccion == 2" color="red darken-1" text @click="desactivar()">Deactivate</v-btn>

              <v-btn v-if="adAccion == 1" color="orange darken-1" text @click="activar()">Activate</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="comprobanteModal" max-width="1000px">
          <v-card>
            <v-card-title class="headline">
              <v-btn @click="crearPDF()" class="mr-3"><v-icon>print</v-icon></v-btn>Sales Report
            </v-card-title>
            <v-card-text>
              <div id="factura">
                <header>
                  <div id="logo">
                    <img src="../assets/Logo.png" id="imagen" />
                  </div>
                  <div id="datos">
                    <p id="encabezado">
                      <b>XWY E&SD, LLC<br />427 NE 112TH Street,<br />MIAMI, Fl.
                        33161,<br />
                        PHONE: 786-329-0191<br />
                        wjimenez@xwyesd.com</b>
                    </p>
                  </div>
                  <div id="fact">
                    <p>
                      {{ tipo_comprobante }}<span> # </span>
                      {{ serie_comprobante }}-{{ num_comprobante }}<br />
                      <span>Date: </span>{{ fecha }}<br />
                      <span>Original</span>
                    </p>
                  </div>
                </header>
                <br />
                <section>
                  <div>
                    <table id="facliente">
                      <tbody>
                        <tr>
                          <td id="cliente">
                            <strong>Bill To: {{ persona.nombre }}</strong><br />
                            <!-- <strong>Tax ID :</strong> -->
                            <!-- {{ persona.num_documento }}<br /> -->
                            <strong>Address: </strong>{{ persona.direccion
                            }}<br />
                            <strong>Phone: </strong> {{ persona.telefono
                            }}<br />
                            <strong>Email: </strong> {{ persona.email }}
                            <!-- <br /> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="job-container">
                      <div class="job-detail-title">Job Details:</div>
                      <div class="job-detail">
                        {{ nombre_proyecto }}
                      </div>
                    </div>
                  </div>
                </section>
                <br />
                <section>
                  <div>
                    <table id="facarticulo">
                      <thead>
                        <tr id="fa">
                          <th>QTY</th>
                          <th>DESCRIPTION</th>
                          <!-- <th>DISCOUNT</th> -->
                          <th></th>
                          <th>UNIT PRICE</th>
                          <th>TOTAL PRICE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="det in detalles" :key="det._id">
                          <td style="text-align: center">{{ det.cantidad }}</td>
                          <td style="text-align: center">{{ det.articulo }}</td>

                          <td style="text-align: center">
                            <!-- {{ det.descuento }} -->
                          </td>
                          <td style="text-align: center">
                            {{ parseFloat(det.precio).toFixed(2) }}
                          </td>
                          <td style="text-align: center">
                            {{
                              parseFloat(
                                det.cantidad * det.precio - det.descuento
                              ).toFixed(2)
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <br />
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style="text-align: left, paddin left: 25px">
                            Sub Total
                          </th>
                          <th style="text-align: right">
                            US${{
                              parseFloat(
                                (totalParcial = calcularTotal)
                              ).toFixed(2)
                            }}
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style="text-align: left, paddin left: 25px">
                            Tax ({{ impuesto }}%)
                          </th>
                          <th style="text-align: right">
                            US${{
                              (totalImpuesto = parseFloat(
                                (totalParcial * impuesto) / 100
                              )).toFixed(2)
                            }}
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style="text-align: left, paddin left: 25px">
                            Total + Tax
                          </th>
                          <th style="text-align: right">
                            US${{
                              (total = parseFloat(
                                totalImpuesto + totalParcial
                              )).toFixed(2)
                            }}
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style="text-align: left, paddin left: 25px">
                            Payment received
                          </th>
                          <th style="text-align: right">
                            US${{
                              (total_pagado = parseFloat(pago).toFixed(2))
                            }}
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style="text-align: left, paddin left: 25px">
                            Pending Payment
                          </th>
                          <th style="text-align: right">
                            US${{
                              (total_pagado = parseFloat(total - pago).toFixed(
                                2
                              ))
                            }}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </section>
                <br />
                <br />
                <footer>
                  <div id="gracias">
                    <p><b>Thank you for using my services!</b></p>
                  </div>
                </footer>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="ocultarComprobante()" color="blue darken-1" text>Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table :headers="headers" :items="ventas" :search="search" class="elevation-1" v-if="verNuevo == 0">
        <template v-slot:[`item.opciones`]="{ item }">
          <v-icon class="mr-2" small @click="editarFactura(item)">
            edit
          </v-icon>
          <v-icon class="mr-2" color="success" small @click="mostrarComprobante(item)">
            print
          </v-icon>
          <v-icon class="mr-2" color="red" small @click="eliminarFactura(item)">
            delete
          </v-icon>
          <!-- <v-icon
						v-if="item.estado"
						small
						@click="activarDesactivarMostrar(2, item)"
					>
						block
					</v-icon>
					<v-icon v-else small @click="activarDesactivarMostrar(1, item)">
						check
					</v-icon> -->
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <div v-if="item.estado">
            <span class="blue--text">Acept</span>
          </div>
          <div v-else>
            <span class="red--text">Cancel</span>
          </div>
        </template>
        <template v-slot:top>
          <v-toolbar text>
            <v-toolbar-title>Income</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field v-if="verNuevo == 0" class="text-xs-center" v-model="search" append-icon="search"
              label="Search" single-line hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-if="verNuevo == 0" @click="mostrarNuevo()" dark class="mb-2">New</v-btn>
          </v-toolbar>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar()"> Reset </v-btn>
        </template>
      </v-data-table>

      <v-container grid-list-sm class="pa-4 white" v-if="verNuevo == 1">
        <v-layout row wrap>
          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-select v-model="tipo_comprobante" :items="comprobantes" label="Type of document"></v-select>
          </v-col>

          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-text-field v-model="serie_comprobante" label="Serie of document"></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-text-field v-model="num_comprobante" label="Number of document"></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="8" md="8" lg="8" xl="8">
            <v-autocomplete :items="personas" v-model="persona" label="Clients"></v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="8" md="8" lg="8" xl="8">
            <!-- <v-text-field
							v-model="nombre_proyecto"
							label="Job Details"
						></v-text-field> -->
            <v-textarea v-model="nombre_proyecto" label="Job Details" no-resize outlined auto-grow></v-textarea>
          </v-col>
          <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
            <v-text-field type="number" v-model="impuesto" label="Tax"></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="8" md="8" lg="8" xl="8">
            <v-text-field v-model="codigo" label="Code" @keyup.enter="buscarCodigo()"></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="2" md="2" lg="2" xl="2">
            <v-btn small fab dark color="primary" @click="mostrarModalArticulos()">
              <v-icon dark>list</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" xs="12" sm="2" md="2" lg="2" xl="2" v-show="errorArticulo">
            <div class="red--text" v-text="errorArticulo"></div>
          </v-col>
          <v-flex cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <template>
              <v-data-table :headers="cabeceraDetalles" :items="detalles" class="elevation-1">
                <template v-slot:[`item.borrar`]="{ item }">
                  <v-icon @click="eliminarDetalle(detalles, item)" small class="mr-2">delete</v-icon>
                </template>
                <template class="text-xs-center" v-slot:[`item.cantidad`]="{ item }">
                  <v-text-field v-model="item.cantidad" type="number"></v-text-field>
                </template>
                <template class="text-xs-right" v-slot:[`item.precio`]="{ item }">
                  <v-text-field v-model="item.precio" type="number"></v-text-field>
                </template>
                <template class="text-xs-right" v-slot:[`item.descuento`]="{ item }">
                  <v-text-field v-model="item.descuento" type="number"></v-text-field>
                </template>
                <template v-slot:[`item.subtotal`]="{ item }">
                  <td class="text-xs-right">
                    US$
                    {{
                      parseFloat(
                        item.cantidad * item.precio - item.descuento
                      ).toFixed(2)
                    }}
                  </td>
                </template>
                <template slot="no-data">
                  <h3>There are no items added to the detail</h3>
                </template>
              </v-data-table>
              <v-flex class="text-xs-right">
                <strong>Subtotal: </strong>
                ${{ parseFloat((totalParcial = calcularTotal)).toFixed(2) }}
              </v-flex>
              <v-flex class="text-xs-right">
                <strong>Total Tax: </strong>
                ${{
                  (totalImpuesto = parseFloat(
                    (totalParcial * impuesto) / 100
                  )).toFixed(2)
                }}
              </v-flex>
              <v-flex class="text-xs-right">
                <strong>Net total: </strong>${{
                  (total = parseFloat(totalImpuesto + totalParcial)).toFixed(2)
                }}
              </v-flex>
            </template>
          </v-flex>
        </v-layout>
        <v-flex cols="12" xs="12" sm="12" md="12" v-show="valida">
          <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
        </v-flex>
        <v-flex cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-2">
          <v-btn class="mr-2 white--text" color="primary" darken-1 text @click.native="ocultarNuevo()">Cancel</v-btn>
          <v-btn v-if="verDetalle == 0" color="success" @click.native="guardar()">Save</v-btn>
          <v-btn v-if="editMode == true" color="success" @click.native="guardarEdicion()">Save Edition</v-btn>
        </v-flex>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export default {
  data() {
    return {
      editMode: false,
      itemCompleto: {},
      dialogDelete: false,
      dialog: false,
      search: '',
      ventas: [],
      headers: [
        { text: 'Opciones', value: 'opciones', sortable: false },
        { text: 'Usuario', value: 'usuario.nombre', sortable: true },
        { text: 'Clientes', value: 'persona.nombre', sortable: true },
        {
          text: 'Tipo Comprobante',
          value: 'tipo_comprobante',
          sortable: true,
        },
        {
          text: 'Serie Comprobante',
          value: 'serie_comprobante',
          sortable: false,
        },
        {
          text: 'Numero Comprobante',
          value: 'num_comprobante',
          sortable: false,
        },
        { text: 'Fecha', value: 'createdAt', sortable: false },
        { text: 'Impuesto', value: 'impuesto', sortable: false },
        { text: 'Total', value: 'total', sortable: false },
        { text: 'Estado', value: 'estado', sortable: false },
      ],
      _id: '',
      persona: '',
      personas: [],
      tipo_comprobante: '',
      comprobantes: ['INVOICE', 'TICKET', 'PAYMENT'],
      serie_comprobante: '',
      num_comprobante: 0,
      nombre_proyecto: '',
      impuesto: 0,
      codigo: '',
      descuento: 0,
      cabeceraDetalles: [
        { text: 'Borrar', value: 'borrar', sortable: false },
        { text: 'Articulo', value: 'articulo', sortable: false },
        { text: 'Cantidad', value: 'cantidad', sortable: false },
        { text: 'Precio', value: 'precio', sortable: false },
        { text: 'Descuento', value: 'descuento', sortable: false },
        { text: 'Sub Total', value: 'subtotal', sortable: false },
      ],
      detalles: [],
      verNuevo: 0,
      errorArticulo: null,
      valida: 0,
      pago: 0,
      total_pagado: 0,
      total: 0,
      totalParcial: 0,
      totalImpuesto: 0,
      articulos: [],
      texto: '',
      precio_venta: '',
      descripcion: '',
      headerArticulo: [
        { text: 'Seleccionar', value: 'seleccionar', sortable: false },
        { text: 'Codigo', value: 'codigo', sortable: false },
        { text: 'Nombre', value: 'nombre', sortable: true },
        { text: 'Categoria', value: 'categoria.nombre', sortable: true },
        { text: 'Stock', value: 'stock', sortable: false },
        { text: 'Precio Venta', value: 'precio_venta', sortable: false },
        { text: 'Descripcion', value: 'descripcion', sortable: false },
        { text: 'Estado', value: 'estado', sortable: false },
      ],
      verDetalle: 0,
      valida: 0,
      validaMensaje: [],
      adModal: 0,
      adAccion: 0,
      adNombre: '',
      adId: '',
      comprobanteModal: 0,
      fecha: null,
    }
  },
  computed: {
    calcularTotal: function () {
      let resultado = 0.0
      for (let i = 0; i < this.detalles.length; i++) {
        resultado =
          resultado +
          this.detalles[i].cantidad * this.detalles[i].precio -
          this.detalles[i].descuento
      }
      return resultado
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
  },

  created() {
    this.listar()
    this.selectPersona()
  },

  methods: {
    //Aqui se inicia la cracion de un pdf para la factura
    crearPDF() {
      let me = this
      var quotes = document.getElementById('factura')
      html2canvas(quotes).then(function (canvas) {
        var imgData = canvas.toDataURL('image/png')
        var imgWidth = 210
        var pageHeight = 295

        var imgHeight = (canvas.height * imgWidth) / canvas.width
        var heightLeft = imgHeight

        var doc = new jsPDF('p', 'mm', 'a4')
        var position = 0

        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
        heightLeft -= pageHeight

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight
          doc.addPage()
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
          heightLeft -= pageHeight
        }
        doc.save(`Invoice-${me.serie_comprobante}-${me.num_comprobante}.pdf`)
      })
    },
    //Convertir timestamp createdAt a fecha
    convertirFecha(createdAt) {
      let fecha = new Date(createdAt)
      let dia = fecha.getDate()
      let mes = fecha.getMonth() + 1
      let anio = fecha.getFullYear()
      // let hora = fecha.getHours();
      // let minutos = fecha.getMinutes();
      // let segundos = fecha.getSeconds();
      let fechaFinal = mes + '/' + dia + '/' + anio //+" " +hora +":" +minutos +":" +segundos
      return fechaFinal
    },
    //Convertir timestamp createdAt a fecha
    fechaToSerieComprobante() {
      let fecha = new Date()
      // let dia = fecha.getDate();
      let mes = fecha.getMonth() + 1
      let anio = fecha.getFullYear()
      // let hora = fecha.getHours();
      // let minutos = fecha.getMinutes();
      // let segundos = fecha.getSeconds();
      let fechaFinal = mes + '-' + anio //+" " +hora +":" +minutos +":" +segundos
      return fechaFinal
    },
    mostrarComprobante(item) {
      this.limpiar()
      this.tipo_comprobante = item.tipo_comprobante
      this.serie_comprobante = item.serie_comprobante
      this.num_comprobante = item.num_comprobante
      this.nombre_proyecto = item.nombre_proyecto
      this.fecha = this.convertirFecha(item.createdAt)
      this.persona = item.persona
      this.impuesto = item.impuesto
      this.pago = item.pagado
      this.listarDetalles(item._id)
      this.comprobanteModal = 1
    },
    async eliminarFactura(item) {
      let me = this
      const id = item._id
      const token = this.$store.state.token
      console.log('ID', id)
      let headersList = {
        Accept: '*/*',
        token: token,
        'Content-Type': 'application/json',
      }

      let bodyContent = JSON.stringify({
        _id: id,
      })

      axios
        .delete('venta/remove', {
          data: bodyContent,
          headers: headersList,
        })
        .then(function (response) {
          me.listar()
        })
        .catch(function (error) {
          console.error(error)
        })
      // let response = await fetch('http://192.168.1.109:3000/api/venta/remove', {
      //   method: 'DELETE',
      //   body: bodyContent,
      //   headers: headersList,
      // })
      //   .then(async function (response) {
      //     let data = await response.json()
      //     console.log('data: ', data)
      //     me.listar()
      //   })
      //   .catch(function (error) {
      //     console.error(error)
      //   })

      // let response = axios.request(reqOptions).then(function (response) {
      // 	// console.log(respone.data)
      // 	me.listar()
      // }).catch(function (error) {
      // 	console.erro(error)
      // })
    },
    editarFactura(item) {
      this.itemCompleto = item
      this.limpiar()
      this.tipo_comprobante = item.tipo_comprobante
      this.serie_comprobante = item.serie_comprobante
      this.num_comprobante = item.num_comprobante
      this.nombre_proyecto = item.nombre_proyecto
      this.persona = item.persona._id
      this.impuesto = item.impuesto
      this.listarDetalles(item._id)
      this.verNuevo = 1
      this.verDetalle = 1
      this.editMode = true
    },
    ocultarComprobante() {
      this.comprobanteModal = 0
    },
    selectPersona() {
      let me = this
      let personaArray = []
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .get('persona/listClientes', configuracion)
        .then(function (response) {
          personaArray = response.data
          personaArray.map(function (x) {
            me.personas.push({ text: x.nombre, value: x._id })
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    buscarCodigo() {
      let me = this
      me.errorArticulo = null
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .get('articulo/queryCodigo?codigo=' + this.codigo, configuracion)
        .then((response) => {
          me.agregarDetalle(response.data)
        })
        .catch(function (error) {
          me.errorArticulo = 'No existe el articulo'
        })
    },
    agregarDetalle(data) {
      this.errorArticulo = null
      if (this.encuentra(data._id) == true) {
        this.errorArticulo = 'El articulo ya ha sido agregado'
      } else {
        this.detalles.push({
          _id: data._id,
          articulo: data.nombre,
          cantidad: 1,
          precio: data.precio_venta.toFixed(2),
          descuento: 0,
        })
      }
      this.codigo = ''
      this.texto = ''
    },
    encuentra(id) {
      let sw = 0
      for (let i = 0; i < this.detalles.length; i++) {
        if (this.detalles[i]._id == id) {
          sw = true
        }
      }
      return sw
    },
    eliminarDetalle(arr, item) {
      let i = arr.indexOf(item)
      if (i != -1) {
        arr.splice(i, 1)
      }
    },
    listarArticulos() {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .get('articulo/list?valor=' + this.texto, configuracion)
        .then(function (response) {
          me.articulos = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    mostrarModalArticulos() {
      this.dialog = true
    },
    listarDetalles(id) {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .get('venta/query?_id=' + id, configuracion)
        .then(function (response) {
          // console.log(response.data);
          me.detalles = response.data.detalles
          me.pago = response.data.pagado
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    verIngreso(item) {
      this.limpiar()
      this.tipo_comprobante = item.tipo_comprobante
      this.serie_comprobante = item.serie_comprobante
      this.num_comprobante = item.num_comprobante
      this.nombre_proyecto = item.nombre_proyecto
      this.persona = item.persona._id
      this.impuesto = item.impuesto
      this.pago = item.pagado
      this.listarDetalles(item._id)
      this.verNuevo = 1
      this.verDetalle = 1
    },
    listar() {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .get('venta/list', configuracion)
        .then((response) => {
          me.ventas = response.data
          // console.log(me.ventas);
          me.ventas.forEach((element) => {
            element.createdAt = this.convertirFecha(element.createdAt)
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    limpiar() {
      this._id = ''
      this.tipo_comprobante = ''
      this.serie_comprobante = ''
      this.num_comprobante = ''
      this.nombre_proyecto = ''
      this.impuesto = 0
      this.codigo = ''
      this.pago = 0
      this.total = 0
      this.totalParcial = ''
      this.totalImpuesto = ''
      this.detalles = []
      this.verNuevo = 0
      this.valida = 0
      this.validaMensaje = []
      this.verDetalle = 0
    },
    validar() {
      this.valida = 0
      this.validaMensaje = []
      if (!this.persona) {
        this.validaMensaje.push('Seleccione un cliente.')
      }
      if (!this.tipo_comprobante) {
        this.validaMensaje.push('Seleccione un tipo de comprobante.')
      }
      // if (!this.num_comprobante) {
      // 	this.validaMensaje.push("Ingrese el numero de comprobante.");
      // }
      if (!this.nombre_proyecto) {
        this.validaMensaje.push('Ingrese el nombre del proyecto.')
      }
      // if (!this.impuesto) {
      // 	this.validaMensaje.push("Ingrese valor de impuesto.");
      // }
      if (this.detalles.length <= 0) {
        this.validaMensaje.push('Ingrese al menos un articulo al detalles.')
      }

      if (this.validaMensaje.length) {
        this.valida = 1
      }
      return this.valida
    },
    mostrarNuevo() {
      this.verNuevo = 1
    },
    ocultarNuevo() {
      this.itemCompleto = {}
      this.editMode = false
      this.verNuevo = 0
      this.limpiar()
    },
    guardar() {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      if (this.validar()) {
        return
      }

      // Codigo para guardar
      axios
        .post(
          'venta/add',
          {
            persona: this.persona,
            usuario: this.$store.state.usuario._id,
            tipo_comprobante: this.tipo_comprobante,
            serie_comprobante: this.fechaToSerieComprobante(),
            num_comprobante: this.num_comprobante,
            nombre_proyecto: this.nombre_proyecto,
            impuesto: this.impuesto,
            total: this.total.toFixed(2),
            detalles: this.detalles,
          },
          configuracion
        )
        .then(function (response) {
          me.limpiar()
          me.close()
          me.listar()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    guardarEdicion() {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      if (this.validar()) {
        return
      }

      // Codigo para guardar
      axios
        .put(
          'venta/update',
          {
            _id: me.itemCompleto._id,
            persona: me.persona,
            usuario: me.$store.state.usuario._id,
            tipo_comprobante: me.tipo_comprobante,
            serie_comprobante: me.serie_comprobante,
            num_comprobante: me.num_comprobante,
            nombre_proyecto: me.nombre_proyecto,
            impuesto: me.impuesto,
            total: me.total.toFixed(2),
            detalles: me.detalles,
          },
          configuracion
        )
        .then(function (response) {
          me.limpiar()
          me.close()
          me.listar()
        })
        .catch(function (error) {
          console.log(error)
        })
      me.editMode = false
      me.itemCompleto = {}
    },
    activarDesactivarMostrar(accion, item) {
      this.adModal = 1
      this.adNombre = item.num_comprobante
      this.adId = item._id
      if (accion == 1) {
        this.adAccion = 1
      } else if (accion == 2) {
        this.adAccion = 2
      } else {
        adModal = 0
      }
    },
    activarDesactivarCarrar() {
      this.adModal = 0
    },

    activar() {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .put('venta/activate', { _id: this.adId }, configuracion)
        .then(function (response) {
          me.adModal = 0
          me.adAccion = 0
          me.adNombre = ''
          me.adId = ''
          me.listar()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    desactivar() {
      let me = this
      let header = { Token: this.$store.state.token }
      let configuracion = { headers: header }
      axios
        .put(
          'venta/deactivate',
          {
            _id: this.adId,
          },
          configuracion
        )
        .then(function (response) {
          me.adModal = 0
          me.adAccion = 0
          me.adNombre = ''
          me.adId = ''
          me.listar()
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    close() {
      this.dialog = false
      this.texto = ''
    },
  },
}
</script>
<style>
#factura {
  padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 16px;
}

#logo {
  float: left;
  margin-left: 2%;
  margin-right: 2%;
}

#imagen {
  width: 75px;
}

#fact {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

#datos {
  float: left;
  margin-top: 0%;
  margin-left: 2%;
  margin-right: 2%;
  /*text-align: justify;*/
}

#encabezado {
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
}

section {
  clear: left;
}

#cliente {
  text-align: left;
}

#facliente {
  width: 50%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 15px;
}

#fa {
  color: #ffffff;
  font-size: 14px;
}

#facarticulo {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  padding: 20px;
  margin-bottom: 15px;
}

#facarticulo thead {
  padding: 20px;
  /* background: #2183e3; */
  background: #003399;
  text-align: center;
  border-bottom: 1px solid #ffffff;
  /* border-radius: 20px; */
}

#gracias {
  text-align: center;
}

.job-container {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  width: 100%;
}

.job-detail-title {
  font-weight: bold;
  font-size: 16px;
  color: red;
}

.job-detail {
  font-size: 14px;
  border: 2px solid #003399;
  border-radius: 10px;
  padding: 10px;
}
</style>
